export default __webpack_public_path__ + "static/media/image-43.0a4c2510.png";